// import { Link } from 'react-router-dom';
import styled from 'styled-components';

// import BannerImage from'./../../../../../../../assets/images/about-banner.svg'
import BannerImage from './../../../../../../../assets/images/about-banner.svg';
export const BannerContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:567px;
background-image:url(${BannerImage});
background-size:cover;
background-repeat:no-repeat;
background-position:bottom right;

`;
export const OverlayContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:567px;
background: linear-gradient(-279.99deg, rgba(25, 173, 118, 0.95) -68.38%, rgba(0, 0, 0, 0.22) 103.46%);
`;



export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 50px;
line-height: 103%;
/* identical to box height, or 52px */


color: #FFFFFF;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;